export default {
      id: "ic_ticket_win_author-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_ticket_win_author-usage",
      toString: function () {
        return this.url;
      }
    }